import React from "react";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../ListItemContextMenu/ListItemContextMenu";

interface StudyViewButtonProps {
    className?: string;
    label: string;
    path: string;
    onOpen: () => void;
}

export function TableActionButton({className, onClick, children}: {
    className: string;
    onClick: () => void;
    children: React.ReactNode;
}) {
    return (
        <div className={className} onClick={onClick} onContextMenu={(event) => event.preventDefault()}>
            {children}
        </div>
    );
}

export function StudyViewButton({className, label, path, onOpen}: StudyViewButtonProps) {
    const menu = useListContextMenu();
    const contextMenuHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        menu.onContextMenu(path, event.clientX, event.clientY);
    };
    return (
        <>
            <div className={className ?? "table-button disable-select"} onClick={onOpen} onContextMenu={contextMenuHandler}>
                {label}
            </div>
            <ListItemContextMenu menuProps={menu.menuProps} anchorPoint={menu.anchorPoint}
                                 onClose={menu.close} onOpen={onOpen}
                                 onOpenInNewTab={() => openInNewTab(path)}
                                 newTabLabelKey="open_in_new_window"/>
        </>
    );
}
